import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AUTH_COLORS, AUTH_FONT } from "../../config/authConstants";

function HrResubmitNotice(props) {
  var comment = props.comment ? String(props.comment).trim() : "";
  var compact = Boolean(props.compact);
  var displayComment =
    comment ||
    "Please review this form, make the required updates, and save again.";

  if (compact) {
    return (
      <Tooltip title={displayComment} arrow placement="top">
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            mt: 0.35,
            maxWidth: "100%",
            cursor: "help",
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 14, color: "#D97706" }} />
          <Typography
            sx={{
              fontFamily: AUTH_FONT,
              fontSize: 11,
              fontWeight: 400,
              color: "#B45309",
              lineHeight: 1.3,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            HR feedback: {displayComment}
          </Typography>
        </Box>
      </Tooltip>
    );
  }

  var embedded = Boolean(props.embedded);

  return (
    <Box
      sx={{
        width: embedded ? "100%" : { xs: "100%", md: "82%" },
        maxWidth: embedded ? "none" : 780,
        mx: embedded ? 0 : "auto",
        mb: embedded ? 0 : 1.5,
        p: embedded ? 1.25 : 1.5,
        borderRadius: "8px",
        border: "1px solid #FCD34D",
        bgcolor: "#FFFBEB",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <InfoOutlinedIcon
          sx={{ fontSize: 18, color: "#D97706", mt: "2px", flexShrink: 0 }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: AUTH_FONT,
              fontSize: 14,
              fontWeight: 600,
              color: "#92400E",
              lineHeight: 1.35,
              mb: 0.5,
            }}
          >
            HR requested changes
          </Typography>
          <Typography
            sx={{
              fontFamily: AUTH_FONT,
              fontSize: 13,
              fontWeight: 400,
              color: AUTH_COLORS.text,
              lineHeight: 1.45,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {displayComment}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default HrResubmitNotice;
